import { render, staticRenderFns } from "./CheckoutLayout.vue?vue&type=template&id=185a3870&"
import script from "./CheckoutLayout.vue?vue&type=script&lang=js&"
export * from "./CheckoutLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports